<template>
  <div class="notfound text-center" :class="{'page-mobile': isMobile}">
    <div class="four-0-four">
      <span>4</span>
      <span class="img-container">
        <img class="huojian" width="41"  src="@/assets/img/comet/huojian.svg" alt="">
        <img class="qiu" width="212" src="@/assets/img/comet/qiu404.svg" alt="">
      </span>
      <span>4</span>
    </div>
    <div class="ooops">{{ $t('common.OhMy') }}</div>
    <p class="ooops-p">{{ $t('common.NoSignal') }}</p>
    <div>
      <ct-button type="primary" @click="goRoute('/live')" :round="true">{{ $t('common.GoHome') }}</ct-button>
    </div>
    <div class="ground">
      <div class="ground-qiu"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NotFound',
  data: () => {
    return {
      isMobile: window.innerWidth < 768
    }
  },
  methods: {
    goRoute (route) {
      this.$router.push(route)
    }
  }
}
</script>
<style lang="scss" scoped>
  .notfound{
    margin-top: 100px;
      color:rgba(26,61,94,1);

  }
  .four-0-four{
    font-size:236px;
    font-family:SFProDisplay-Regular;
    font-weight:400;
    line-height:236px;
  }
  .img-container{
      position: relative;
      padding: 0 8px;
      .huojian{
        position: absolute;
        right: 0;
      }
    }
  .ooops{
    font-size:32px;
    font-family:SFProDisplay-Semibold;
    font-weight:600;
    margin-top: 40px;
    &-p{
      font-size:16px;
      font-family:SFProText-Regular;
      font-weight:400;
      color:rgba(54,85,114,1);
      line-height:16px;
      margin:24px 0 40px;
    }
  }
  .ground{
    position: absolute;
    bottom: -200px;
    width: 100%;
    height:373px;
    z-index: 1100;
    background:#fff;

    &-qiu{
      border-radius: 50%;
      background:rgba(247,251,255,1);
      height: inherit;
    }
  }
    .page-mobile{
        .four-0-four{
            font-size: 100px;
            font-family:SFProDisplay-Regular;
            font-weight:400;
            line-height:236px;
        }
        .img-container {
            .qiu {
                width: 90px!important;
            }
            .huojian {
                width: 30px!important;
            }
        }
        .ooops {
            margin-top: 10px;
        }
        .ooops-p {
            padding: 0 20px;
        }
        .ground {
            z-index: -1
        }
    }
</style>
